import { Component } from "@angular/core";
import { Title } from '@angular/platform-browser';

@Component({
    selector: 'unit-five-lesson-two-guide',
    templateUrl: './_guide.component.html',
    styleUrls: ['../../_shared/lesson-guides/lesson-guide.component.css']
})
export class UnitFiveLessonTwoGuideComponent {

    pageTitle: string = "Lesson Guide | Unit 5, Lesson 2 | T-Folio";
    title: string = "Lesson Guide";
    subtitle: string = "Lesson 2: Self-Advocacy Goals";

    public constructor(private titleService: Title) {
        this.titleService.setTitle(this.pageTitle);
    }
}
